// React-Query constants

export const GET_CURRENT_USER_QUERY_KEY = 'GET_CURRENT_USER_QUERY_KEY';
export const GET_USER_DATA_KEY = 'GET_USER_DATA_KEY';
export const GET_USER_PREFERENCES_KEY = 'GET_USER_PREFERENCES_KEY';
export const GET_USER_PASSWORD_KEY = 'GET_USER_PASSWORD_KEY';

export const GET_APP_CONFIG_KEY = 'GET_APP_CONFIG_KEY';
export const GET_MAP_SHAPES_KEY = 'GET_MAP_SHAPES_KEY';

export const GET_HORODATETIME_KEY = 'GET_HORODATETIME_KEY';
export const GET_DAILY_WEATHER_DATA_QUERY_KEY =
  'GET_DAILY_WEATHER_DATA_QUERY_KEY';
export const GET_DATA_QUERY_KEY = 'GET_DATA_QUERY_KEY';
export const GET_LICENCE_AREAS_QUERY_KEY = 'GET_LICENCE_AREAS_QUERY_KEY';
export const GET_LICENCE_AREA_QUERY_KEY = 'GET_LICENCE_AREA_QUERY_KEY';
export const GET_LICENCE_AREA_FAULT_BANDS_QUERY_KEY =
  'GET_LICENCE_AREA_FAULT_BANDS_QUERY_KEY';
export const GET_LICENCE_AREA_DISTRICTS_QUERY_KEY =
  'GET_LICENCE_AREA_DISTRICTS_QUERY_KEY';
export const GET_LICENCE_AREA_DISTRICTS_FAULT_AND_WEATHER_FORECASTS_BREAKDOWN_QUERY_KEY =
  'GET_LICENCE_AREA_DISTRICTS_FAULT_AND_WEATHER_FORECASTS_BREAKDOWN_QUERY_KEY';
export const GET_LICENCE_AREA_DISTRICTS_FAULT_AND_WEATHER_FORECASTS_DAILY_QUERY_KEY =
  'GET_LICENCE_AREA_DISTRICTS_FAULT_AND_WEATHER_FORECASTS_DAILY_QUERY_KEY';
export const GET_DISTRICT_QUERY_KEY = 'GET_DISTRICT_QUERY_KEY';
export const GET_DISTRICT_FAULT_AND_WEATHER_FORECAST_BREAKDOWN_QUERY_KEY =
  'GET_DISTRICT_FAULT_AND_WEATHER_FORECAST_BREAKDOWN_QUERY_KEY';
export const GET_DISTRICT_FAULT_AND_WEATHER_FORECAST_QUERY_KEY =
  'GET_DISTRICT_FAULT_AND_WEATHER_FORECAST_QUERY_KEY';
export const GET_DISTRICT_WEATHER_EVENTS_QUERY_KEY =
  'GET_DISTRICT_WEATHER_EVENTS_QUERY_KEY';
export const GET_DISTRICT_SIMILAR_EVENTS_QUERY_KEY =
  'GET_DISTRICT_SIMILAR_EVENTS_QUERY_KEY';
export const GET_DISTRICT_SIMILARITY_QUERY_KEY =
  'GET_DISTRICT_SIMILARITY_QUERY_KEY';
export const GET_DISTRICT_FAULT_FORECASTS_QUERY_KEY =
  'GET_DISTRICT_FAULT_FORECASTS_QUERY_KEY';
export const GET_DISTRICT_FAULT_FORECASTS_BY_FAULT_BAND_QUERY_KEY =
  'GET_DISTRICT_FAULT_FORECASTS_BY_FAULT_BAND_QUERY_KEY';
export const GET_SIMULATION_FORECAST_BREAKDOWN_QUERY_KEY =
  'GET_SIMULATION_FORECAST_BREAKDOWN_QUERY_KEY';
export const GET_SIMULATION_FORECAST_QUERY_KEY =
  'GET_SIMULATION_FORECAST_QUERY_KEY';
export const GET_SIMULATION_FORECAST_BY_FAULT_BAND_QUERY_KEY =
  'GET_SIMULATION_FORECAST_BY_FAULT_BAND_QUERY_KEY';
export const GET_DISTRICT_EXTREME_WEATHER_FORECAST_QUERY_KEY =
  'GET_DISTRICT_EXTREME_WEATHER_FORECAST_QUERY_KEY';
export const GET_DISTRICT_FAULT_BANDS_QUERY_KEY =
  'GET_DISTRICT_FAULT_BANDS_QUERY_KEY';
export const GET_DISTRICT_HOURLY_FORECAST_QUERY_KEY =
  'GET_DISTRICT_HOURLY_FORECAST_QUERY_KEY';
export const GET_MARKER_HOURLY_FORECAST_QUERY_KEY =
  'GET_MARKER_HOURLY_FORECAST_QUERY_KEY';
export const GET_MAP_POPIN_WEATHER_FORECAST_QUERY_KEY =
  'GET_MAP_POPIN_WEATHER_FORECAST_QUERY_KEY';
export const GET_WEATHER_EVENT_DETAILS_QUERY_KEY =
  'GET_WEATHER_EVENT_DETAILS_QUERY_KEY';
export const GET_FAULT_BREAKDOWN_KEY = 'GET_FAULT_BREAKDOWN_KEY';
export const GET_NETWORK_IMPACT_KEY = 'GET_NETWORK_IMPACT_KEY';
export const GET_ACTION_PLAN_KEY = 'GET_ACTION_PLAN_KEY';
export const GET_WEATHER_EVENTS_QUERY_KEY = 'GET_WEATHER_EVENTS_QUERY_KEY';
export const GET_RESOURCE_CALCULATOR_PARAMETERS_QUERY_KEY =
  'GET_RESOURCE_CALCULATOR_PARAMETERS_QUERY_KEY';
export const GET_USERS_QUERY_KEY = 'GET_USERS_QUERY_KEY';
export const GET_MAIL_SUBCRIPTIONS_QUERY_KEY =
  'GET_MAIL_SUBCRIPTIONS_QUERY_KEY';
export const GET_WEATHER_EVENT_LICENCE_AREA_QUERY_KEY =
  'GET_WEATHER_EVENT_LICENCE_AREA_QUERY_KEY';
export const GET_NETWORK_IMPACT = 'GET_NETWORK_IMPACT_KEY';
export const GET_RESOURCE_CALCULATOR_RESULTS_QUERY_KEY =
  'GET_RESOURCE_CALCULATOR_RESULTS_QUERY_KEY';
export const GET_FORECAST_QUALITY = 'GET_FORECAST_QUALITY';
export const GET_WIND_PARTICULES = 'GET_WIND_PARTICULES';
export const GET_WIND_PARTICULES_JSON = 'GET_WIND_PARTICULES_JSON';
